import { imageConfig, type imageTypes, refreshImageConfig, type refreshImageTypes } from 'config/images';

export const getSizes = (imageType: imageTypes) => {
  const config = imageConfig[imageType];
  return config.breakpoints
    .map((breakpoint, index) => `(min-width: ${breakpoint}px) ${config.sizes[index]}px`)
    .concat(`${config.fallback}px`)
    .join(', ');
};

export const getRefreshSizes = (imageType: refreshImageTypes) => {
  const config = refreshImageConfig[imageType];
  return config.breakpoints
    .map((breakpoint, index) => `(min-width: ${breakpoint}px) ${config.sizes[index]}px`)
    .concat(config.fallback ? `${config.fallback}px` : '94vw')
    .join(', ');
};

export const getFilename = (filename?: string, alt?: string) => {
  if (typeof filename === 'string' && !filename.includes('image')) {
    return filename;
  } else if (alt) {
    return alt.replace('Bild zu: ', '');
  }
  return 'image';
};

export const normalizeBaseUrl = (url: string) => {
  // check if it is a complete url
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  // else, assume it's base64 encoded and decode it
  try {
    const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/;
    if (!base64Regex.test(url)) {
      return url;
    }

    const decoded = Buffer.from(url, 'base64').toString('utf-8');
    if (decoded.includes('http://') || decoded.includes('https://')) {
      return decoded;
    }
    return url;
  } catch {
    return url;
  }
};
